module.exports = __webpack_public_path__ + "static/media/3.0579fb21.jpg";